import React, {useRef, useState} from 'react';
import {DirectoryBar} from '../../components/DirectoryBar';
import {Button} from '../../components/Button';
import {H3} from '../../components/H3';
import {TextArea} from '../../components/TextArea';
import {TextField} from '../../components/TextField';
import {ReactComponent as FileClipIcon} from '../../assets/svg/file-clip.svg';
import {postCustomers} from "../../apis/user";
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import {CustomerBoardDto} from "../../types/types";
import {nToast} from '../../plugins/reactToast';

const MAX_FILE_COUNT = 3

export const InquireAdd = () => {
    const history = useHistory()
    const [inquireFile, setInquireFile] = useState<File[]>([]);
    const [inquire, setInquire] = useState<string | undefined>();
    const inquireUploadRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const _parseFileName = (url: string | undefined) => {
        if (url) {
            const splitUrl = url.split('/');
            const fileName = splitUrl[splitUrl.length - 1];
            const splitFileName = fileName.split('_');
            splitFileName.shift();
            return decodeURI(splitFileName.join(''));
        }
    };
    const form = useForm<CustomerBoardDto>()

    const onSubmit = (data: CustomerBoardDto) => {
        postCustomers(data, inquireFile).then(r => history.goBack()).catch(e => console.log(e));
    }

    return (
        <form onSubmit={form.handleSubmit(onSubmit)}>
            <DirectoryBar text="1:1 문의 작성하기" backArrow className="md:hidden"/>
            <div className="space-y-5 mb-10">
                {/* <H3 className="my-4 border-b border-gray-800 py-4">1:1 문의 작성하기</H3> */}

                <TextField label="제목" placeholder="제목을 입력해주세요." {...form.register(`title`, {required: true})}/>
                <TextArea
                    label="내용"
                    placeholder="내용을 입력해주세요."
                    className="h-44"
                    {...form.register(`contents`, {required: true})}
                />
                <div>
                    <label
                        htmlFor="inquireUpload"
                        className="outlined-black font-light text-sm cursor-pointer px-12 py-4"
                    >
                        파일 업로드
                    </label>
                </div>

                {inquireFile.length
                    ? inquireFile.map((file) => (
                        <div
                            className="w-full flex flex-row justify-between mt-2 py-3 px-4 border-border-gray border rounded-md">
                            <div className="flex flex-row justify-items-center">
                                <FileClipIcon/>
                                <span className="text-sm text-black-0 ml-3">{file?.name}</span>
                            </div>
                            <button type={'button'}
                                    onClick={() => setInquireFile(inquireFile.filter((el) => el !== file))}
                                    className="text-sm text-red-500"
                            >
                                {'삭제'}
                            </button>
                        </div>
                    ))
                    : ''}

                <input
                    ref={inquireUploadRef}
                    type="file"
                    multiple
                    id="inquireUpload"
                    className="hidden"
                    // accept="image/*, .pdf"
                    onChange={(e) => {
                        let newFiles: File[] = [];

                        if (e.target.files) {
                            const totalFileCount = inquireFile.length + e.target.files.length;

                            for (let i = 0; i < e.target.files.length; i++) {
                                const item: File | null = e.target.files.item(i);
                                if (item) {
                                    newFiles.push(item);
                                }
                            }

                            if (totalFileCount > MAX_FILE_COUNT) {
                              nToast('파일은 최대 3개까지 업로드할 수 있습니다.')
                              return
                            }
                        }
                        setInquireFile(inquireFile.concat(newFiles));
                    }}
                />

                <div className="grid place-content-end">
                    <Button type={'submit'}
                            text="등록하기"
                            className="filled-black px-16 text-sm font-light"
                    />
                </div>
            </div>
        </form>
    );
};
